import React, { useState } from "react";
import dayjs from "dayjs";
import { Col, Row } from "../../components/Layout";
import { SearchAutoComplete } from "./SearchAutoComplete";

export const VesselFormElements = (props) => {
    const { portOfExitList, portOfEntryList, vesselList, blNumberError,containerNumberError,sailDateError, etaError,portError } = props;
  
    const [portOfExit, setPortOfExit] = useState('');
    const [portOfEntry, setPortOfEntry] = useState('');
    const [vessel, setVessel] = useState('');
    const [blNumber, setBlNumber] = useState('');
    const [containerNumber, setContainerNumber] = useState('');
    const [sailDate, setSailDate] = useState(null);
    const [eta, setEta] = useState(null);
    const maxSailDate = dayjs().add(60, 'day').format('YYYY-MM-DD');
    const minSailDate = dayjs().subtract(60, 'day').format('YYYY-MM-DD');
    const maxEtaDate = dayjs().add(180, 'day').format('YYYY-MM-DD');
    const minEtaDate = dayjs().subtract(60, 'day').format('YYYY-MM-DD');

    const handleVesselChange = (event, newValue) => {
      const vesselValue = newValue ? newValue.value : '';
      setVessel(newValue);
    };
    
    return (
      <Col className="text-base space-y-4">
        <Row className="items-center">
          <label className="text-xs w-40 flex-shrink-0">Port of Exit :</label>
          <div className="flex-1">
            <select
              className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]" 
              name="portOfExit"
              value={portOfExit}
              onChange={(event) => setPortOfExit(event.target.value)}
            >
              <option value="" disabled>Select Port</option>
              {portOfExitList.map((port) => (
                <option key={port.locationId} value={port.locationId}>
                  {port.descr}
                </option>
              ))}
            </select>
          </div>
        </Row>

        <Row className="items-center">
          <label className="text-xs w-40 flex-shrink-0">Port of Entry :</label>
          <div className="flex-1">
            <select
              className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]" 
              name="portOfEntry"
              value={portOfEntry}
              onChange={(event) => setPortOfEntry(event.target.value)}
            >
              <option value="" disabled>Select Port</option>
              {portOfEntryList.map((port) => (
                <option key={port.locationId} value={port.locationId}>
                  {port.descr}
                </option>
              ))}
            </select>
            {portError && (
              <p className="text-xs text-red-500 mt-1">
                Port of Exit and Port of Entry cannot be the same
              </p>
            )}
          </div>
        </Row>

        <Row className="items-center">
          <label className="text-xs w-40 flex-shrink-0">Vessel :</label>
          <div className="flex-1">
            <SearchAutoComplete
              name="vessel"
              TextFieldProps={{
                variant: 'outlined',
                placeholder: 'Search..'
              }}
              options={vesselList.map(vessel => ({
                value: vessel.imo,
                label: `${vessel.name_org} (${vessel.imo})`
              }))}
              onChange={handleVesselChange}
              value={vessel}
              className="text-xs w-full"
            />
          </div>
        </Row>

        <Row className="items-center">
          <label className="text-xs w-40 flex-shrink-0">B/L Number :</label>
          <div className="flex-1">
            <input
              className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]"
              name="blNumber"
              value={blNumber}
              onChange={(event) => setBlNumber(event.target.value)}
              type="text"
              maxLength="16"
              minLength="8"
            />
            {blNumberError && (
              <p className="text-xs text-red-500 mt-1">
                BL Number is invalid
              </p>
            )}
          </div>
        </Row>

        <Row className="items-center">
          <label className="text-xs w-40 flex-shrink-0">Container Number :</label>
          <div className="flex-1">
            <input
              className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]"
              name="containerNumber"
              value={containerNumber}
              onChange={(event) => setContainerNumber(event.target.value)}
              type="text"
              maxLength="11"
            />
            {containerNumberError && (
              <p className="text-xs text-red-500 mt-1">
                Container Number is invalid
              </p>
            )}
          </div>
        </Row>

        <Row className="items-center">
          <label className="text-xs w-40 flex-shrink-0">Sail Date :</label>
          <div className="flex-1">
            <input
              type="date"
              className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]"
              name="sailDate"
              value={sailDate || ""}
              placeholder="Select Date"
              onChange={(event) => setSailDate(event.target.value)}
              min={minSailDate}
              max={maxSailDate}
            />
            {sailDateError && (
              <p className="text-xs text-red-500 mt-1">
                Date is invalid
              </p>
            )}
          </div>
        </Row>

        <Row className="items-center">
          <label className="text-xs w-40 flex-shrink-0">ETA :</label>
          <div className="flex-1">
            <input
              type="date"
              className="text-xs w-full border-[1px] border-gray-500 rounded-sm p-[3px]"
              name="eta"
              value={eta}
              onChange={(event) => setEta(event.target.value)}
              min={minEtaDate}
              max={maxEtaDate}
              placeholder="Select Date"
            />
            {etaError && (
              <p className="text-xs text-red-500 mt-1">
                Date is invalid
              </p>
            )}
          </div>
        </Row>
      </Col>
    );
  };
  